import { CarouselItem } from '@/components/ui/carousel'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { useTranslation } from 'react-i18next'
import { useNeedsAnalysis } from '@/contexts/needs-analysis/NeedsAnalysisContext'
import type { WeeklyTimeCommitment } from '@/types/learner-portal'

const WEEKLY_TIME_OPTIONS: WeeklyTimeCommitment[] = ['Less than 1 hour', '1-2 hours', '2-3 hours', 'More than 3 hours']

const TIME_OPTION_KEYS: Record<WeeklyTimeCommitment, string> = {
  'Less than 1 hour': 'lessThan1',
  '1-2 hours': '1to2',
  '2-3 hours': '2to3',
  'More than 3 hours': 'moreThan3',
}

export default function WeeklyHoursScreen() {
  const { t } = useTranslation()
  const { weekly_time_commitment, setTimeCommitment } = useNeedsAnalysis()

  return (
    <CarouselItem className='px-2 sm:px-8'>
      <div className='space-y-2 py-2 sm:space-y-6 sm:py-6'>
        <div className='space-y-1 sm:space-y-2'>
          <h3 id='weekly-hours-heading' className='text-base font-medium text-gray-900 sm:text-xl'>
            {t('needsAnalysis.weeklyTime.title')}
          </h3>
        </div>

        <RadioGroup
          aria-labelledby='weekly-hours-heading'
          value={weekly_time_commitment || undefined}
          onValueChange={(val) => setTimeCommitment(val as WeeklyTimeCommitment)}
          className='space-y-2 sm:space-y-3'
        >
          {WEEKLY_TIME_OPTIONS.map((option) => (
            <Label
              key={option}
              htmlFor={`time-${option}`}
              className='flex cursor-pointer items-center space-x-2 rounded-lg border border-gray-200 p-2 transition-colors hover:bg-gray-50 sm:space-x-3 sm:p-4'
            >
              <RadioGroupItem value={option} id={`time-${option}`} />
              <span className='flex-1 text-sm font-medium sm:text-base'>
                {t(`needsAnalysis.weeklyTime.options.${TIME_OPTION_KEYS[option]}`)}
              </span>
            </Label>
          ))}
        </RadioGroup>
      </div>
    </CarouselItem>
  )
}
